import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Twitch } from 'lucide-react';

export const TwitchCTASection = () => (
  <section className="py-12 sm:py-20 px-4">
    <div className="max-w-4xl mx-auto text-center">
      <Card className="twitch-card border-4">
        <CardContent className="p-8 sm:p-12">
          <Twitch className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-6 text-blue-400" />
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black game-show-text mb-4">
            JOIN THE GAME SHOW!
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 mb-8 font-bold">
            Catch Ciro Game Show streaming follow and become a contestant!
          </p>
          <a 
            href="https://www.twitch.tv/CiroGameShowTwitch"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <Button 
              size="lg" 
              className="text-xl sm:text-2xl font-black py-6 px-8 sm:px-12 bg-blue-600 hover:bg-blue-500 border-4 border-blue-400 pulse-button"
            >
              <Twitch className="mr-3 w-6 h-6 sm:w-8 sm:h-8" />
              FOLLOW ON TWITCH
            </Button>
          </a>
        </CardContent>
      </Card>
    </div>
  </section>
);
